import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ShieldAlert, Loader2 } from "lucide-react";
import { isAuthenticated, getCurrentUser } from "../utils/auth";

const ProtectedRoute = ({ element, allowedRoles }) => {
    const [isChecking, setIsChecking] = React.useState(true);
    const [isAuthorized, setIsAuthorized] = React.useState(false);
    const user = getCurrentUser();

    useEffect(() => {
        const checkAuth = () => {
            setIsChecking(true);
            const auth = isAuthenticated();

            if (!auth) {
                setIsAuthorized(false);
            } else if (allowedRoles && (!user || !allowedRoles.includes(user.role))) {
                setIsAuthorized(false);
            } else {
                setIsAuthorized(true);
            }

            setIsChecking(false);
        };

        checkAuth();
    }, [allowedRoles, user]);

    if (isChecking) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-background">
                <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    className="text-center"
                >
                    <Loader2 className="w-12 h-12 text-primary-600 animate-spin mx-auto mb-4" />
                    <p className="text-gray-600">Verifying access permissions...</p>
                </motion.div>
            </div>
        );
    }

    if (!isAuthenticated()) {
        return <Navigate to="/login" replace />;
    }

    if (!isAuthorized) {
        return <Navigate to="/unauthorized" replace />;
    }

    return element;
};

export default ProtectedRoute;